/**
 * @generated SignedSource<<9e3e16b02d7e839cb28fafbd9cc22027>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09

import type { ConcreteRequest } from 'relay-runtime';
export type preloadLegacyBridgeQuery$variables = {
  contentId: string;
  isBlog: boolean;
};
export type preloadLegacyBridgeQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
        readonly type: string | null;
      } | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly ptpage?: {
    readonly id: string;
    readonly nearestAncestors: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly title: string | null;
        };
      } | null> | null;
    } | null;
  } | null;
};
export type preloadLegacyBridgeQuery = {
  response: preloadLegacyBridgeQuery$data;
  variables: preloadLegacyBridgeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isBlog"
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = [
  {
    "condition": "isBlog",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "status",
            "value": [
              "CURRENT"
            ]
          }
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "ptpage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
              {
                "concreteType": "PTPageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "nearestAncestors(first:1)"
          }
        ]
      }
    ]
  },
  {
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "number"
              }
            ]
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              (v4/*: any*/)
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadLegacyBridgeQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadLegacyBridgeQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "1eef94f086d4818dc81396289138687a",
    "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
    "metadata": {},
    "name": "preloadLegacyBridgeQuery",
    "operationKind": "query",
    "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "6d396d281028b16cc64fd39e7d8cd3db";

export default node;
